<div class="flex">
    <div class="w-1/2 pr-4">
        {#if mounted}
            <InputAsmSelect filterObject="{filterObject}"
                            valueFromUrl="{values.line}"
                            config={config}
                            on:updateFilter={(event) => onUpdateFilter(event.detail.filterObject, "line", event.detail.value)}
            />
        {/if}
    </div>
    <div class="w-1/2">
        <label for="radius-{filterObject.id}">Radius</label>
        <input type="number" id="radius-{filterObject.id}"
               class="h-10 inline border border-gray-200 w-full p-2 px-3 rounded focus:outline-none invalid:bg-red-50 invalid:border-red-500" required placeholder="Wert eingeben"
               step="0.1" min="0" value="{values.radius}"
               on:input={(e) => {onUpdateFilter(filterObject, "radius", e.target.value) }}>
    </div>
</div>

<script>
    import {createEventDispatcher, onMount} from "svelte";
    import InputAsmSelect from "./asm-select.svelte";

    const dispatch = createEventDispatcher();

    export let filterObject;

    export let config;

    let mounted = false;

    let values = {
        line: "",
        radius: "0"
    };

    onMount(() => {
        const filterValues = filterObject.getValue();
        const valuesArray = filterValues.split(",");
        values.line = valuesArray[0] || "";
        values.radius = valuesArray[2] || "0";

        mounted = true;
    });

    function onUpdateFilter(filterObject, type, value) {
        values[type] = value;

        dispatch("updateFilter", {
            filterObject,
            type: "values",
            value: `${values.line},0,${values.radius.replace(/[^0-9,.]/g, "").replace(/,/g, ".")}`
        });
    }

</script>